import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import PopupBox from '../../components/shared/PopupBox';
import HelpText from '../../components/help/HelpText';
import ModalContainerTrigger from '../../components/shared/ModalContainerTrigger'
import TypeOfPersonSelect from '../../components/shared/TypeOfPersonSelect';

import { adminUser, managerUser, renderErrorWarning, renderErrors } from '../../utilities/Forms.js'
import { convertToTwentyFourHourTime, debounce } from '../../utilities/Generic.js'

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

class AssignServiceModal extends Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handlePartialChange = this.handlePartialChange.bind(this);
    this.debouncedHandlePersonSearch = debounce(this.handlePersonSearch.bind(this), 500);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    showModal: false,

    partial: "",
    type_of_person: "",
    host_person_id: "",
    service_id: "",
    start_time: this.formatDatetime(this.props.start_time),
    end_time: this.formatDatetime(this.props.end_time),

    people: [],
    services: [],

    peopleLoaded: true, // So it doesn't say "Loading..." before anything is typed
    servicesLoaded: false,

    unauthorized: "",
    errors: "",
    error: "",

    timezone_string: ""
  }

  formatDatetime(datetimeString) {
    let [date, time] = datetimeString.split(" ")

    let [day, month, year] = date.split("/")

    return `${year}-${month}-${day}T${convertToTwentyFourHourTime(time)}`
  }

  openModal(event) {
    if (this.state.servicesLoaded === false) {
      this.grabServices()
    }

    this.setState({ showModal: true })
  }

  closeModal(event) {
    this.setState({ showModal: false })
  }

  compileTime(datetime, timezone_string) {
    const jsDate = new Date(`${datetime}${timezone_string}`)
    return jsDate.toString()
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleTypeChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    this.handlePersonSearch(this.state.partial, value)
  }

  handlePartialChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value,
      peopleLoaded: false
    });

    this.debouncedHandlePersonSearch(value, this.state.type_of_person)

    event.preventDefault()
  }

  handlePersonSearch(partial, type_of_person) {
    if (partial.trim() === "") {
      this.setState({ peopleLoaded: true });
      return
    }

    let params = `person[location]=${this.props.location_id}&person[partial]=${partial}`

    if (type_of_person !== "") {
      params += `&person[type][]=${type_of_person}`
    }

    request('GET', `/v1/a/people/scoped_names_and_ids?${params}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, peopleLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, peopleLoaded: true })
      })
  }

  handleSubmit(event) {
    if (!this.formIsValid()) {
      return
    }

    var json = JSON.stringify({
      "planned_event": {
        "start_time": this.compileTime(this.state.start_time, this.state.timezone_string),
        "end_time": this.compileTime(this.state.end_time, this.state.timezone_string),
        "planned_event_arriving_people_attributes": [{"person_id": this.props.person_id, "event_id": this.props.event_id}],
        "planned_event_host_people_attributes": [{"person_id": this.state.host_person_id}],
        "service_id": this.state.service_id,
        "location_id": this.props.location_id
      }
    })

    request("POST", `/v1/a/planned_events`, json, () => { this.setState({ unauthorized: true }) })
      .then(data => {
        sessionStorage.setItem("updateSuccess", "Service assigned successfully!");

        if (data.service_id) {
          this.props.setService(data.service_id, this.state.services.find(service => service.id === data.service_id).name)
        }

        this.closeModal()
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ error: error })
        }
        else {
          this.setState({ errors: error })
        }
      })

    event.preventDefault();
  }

  formIsValid() {
    let errors = {}
    if (this.state.host_person_id === "") {
      errors.host = "is required"
    }

    if (this.state.service_id === "") {
      errors.service = "is required"
    }

    if (Object.keys(errors).length === 0) {
      errors = ""
    }

    this.setState({ errors })
    return errors === ""
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input className="top-space" type="submit" value="Save" onClick={this.handleSubmit} />
    }
    else {
      return <input className="top-space" type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  render() {
    const { showModal, partial, type_of_person, host_person_id, service_id, start_time, end_time, people, services, servicesLoaded, peopleLoaded, unauthorized, errors, error } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    return (
      <>
        <div className="small button right" onClick={this.openModal}>Assign Service</div>

        <ModalContainerTrigger modalTitle="Assign a Service" openModal={this.openModal} closeModal={this.closeModal} showModal={showModal} visibleOverflow={true}>
          <div className="row">
            <HelpText page={'planned_events'} section={'service'} />

            <label className="column">Service:</label>{ renderErrors(errors, 'service') }
            <select name="service_id" onChange={this.handleChange} value={service_id}>
              <option value="">{servicesLoaded ? "Select" : "Loading..."}</option>
              {services.map((service) => (
                <option value={service.id} key={service.id}>{service.name} ({service.duration} minutes)</option>
              ))}
            </select>
          </div>

          <div className="row">
            <HelpText page={'planned_events'} section={'host_people'} />

            <label className="column">Select Host:</label>{ renderErrors(errors, 'host') }
            <TypeOfPersonSelect className="small-bottom-margin" defaultText="Filter by Person Type" value={type_of_person} onChange={this.handleTypeChange} />

            <input name="partial" placeholder="Enter text to search" className="no-margin" onChange={this.handlePartialChange} value={partial} />
            <select name="host_person_id" className="no-margin" onChange={this.handleChange} value={host_person_id}>
              <option value="">{peopleLoaded ? `Select a Person (${this.state.people.length})` : "Loading..."}</option>
              {people.map((person) => (
                <option value={person.id} key={person.id} disabled={this.props.person_id === person.id}> {person.full_name}</option>
              ))}
            </select>
          </div>

          <div className="half-row top-padding">
            <div className="row">
              <label className="column">Start Time:</label>{ renderErrors(errors, 'start_time') }
              <HelpText className="inline-block" page={'planned_events'} section={'start_time'} />

              <div>
                <input className="column" type="datetime-local" name="start_time" value={start_time} onChange={this.handleChange} />
              </div>
            </div>

            <div className="row">
              <label className="column">End Time:</label>{ renderErrors(errors, 'end_time') }
              <HelpText className="inline-block"page={'planned_events'} section={'end_time'} />

              <div>
                <input className="column" type="datetime-local" name="end_time" value={end_time} onChange={this.handleChange} />
              </div>
            </div>
          </div>

          { this.renderSaveButton() }
          { renderErrorWarning(errors) }
        </ModalContainerTrigger>

        <PopupBox />
      </>
    );
  }

  grabServices() {
    request('GET', `/v1/a/services/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ services: data, servicesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, servicesLoaded: true })
      })
  }
}

export default AssignServiceModal
